import { withInstall } from '@ll-plus/utils'

import Barcode from './src/barcode.vue'

export const LlBarcode = withInstall(Barcode)
export default LlBarcode
export * from './src/barcode'

declare module 'vue' {
  export interface GlobalComponents {
    LlBarcode: typeof Barcode
  }
}
